<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Delete solution</h5>
        <p class="component-paragraph">
          Are you sure you want to delete this solution?
          <br />
          <strong>{{ solution.name }}</strong>
        </p>

        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
          <input
            type="submit"
            class="btn btn-secondary"
            value="Delete"
            @click="clickedDelete"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DeleteSolutionModal",
  data() {
    return {
      show: true
    };
  },
  props: ["solution"],
  methods: {
    clickedDelete() {
      this.$emit("onDeleteSolution", this.solution);
      this.show = false;
    },
    clickedCancel() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
    margin: 0 0 30px 0;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
